import { useGameList } from "./useGameList.ts";

export const useGameBefore = (competitionId?: string) => {
  const games = useGameList(competitionId);
  if (!games.isSuccess) {
    return null;
  }

  const gameBefore = games.data.games.filter((g) => g.result);

  if (gameBefore.length == 0) {
    return null;
  }

  return gameBefore[gameBefore.length - 1];
};
